import Vue from 'vue'

import eventbus from '@/plugins/eventbus'
import axiosPlugin from '@/plugins/axios'
import stompPlugin from '@/plugins/stomp'

Vue.use(eventbus);
Vue.use(axiosPlugin);
Vue.use(stompPlugin);

import {get,merge,cloneDeep,has,forOwn} from 'lodash'

Vue.use((Vue) => {
  Vue.$lodash = {get,merge,cloneDeep,has}
  Object.defineProperties(Vue.prototype, {
    $lodash: { get() { return {get,merge,cloneDeep,has} } }
  })
})

Vue.use((Vue) => {
  function nestedSet (obj, path, value) {
    const isNumberLike = (value) => String(value).match(/^\d+$/)

    let fields = Array.isArray(path)
      ? path
      : path.split(".")
    let prop = fields.shift()

    if (!fields.length) return Vue.set(obj, prop, value)
    if (!Object.prototype.hasOwnProperty.call(obj, prop) || obj[prop] === null) {
      const objVal = fields.length >= 1 && isNumberLike(fields[0]) ? [] : {}
      Vue.set(obj, prop, objVal)
    }
    nestedSet(obj[prop], fields, value)
  }
  Vue.$nestedSet = nestedSet
  Object.defineProperties(Vue.prototype, {
    $nestedSet: { get() { return nestedSet } }
  })
  //-----------------------------------------------------------
  function deletePropertyPath (obj, path) {
    if (!obj || !path) return;

    if (typeof path === 'string') path = path.split('.');

    for (var i = 0; i < path.length - 1; i++) {
      obj = obj[path[i]];
      if (typeof obj === 'undefined') return;
    }
    delete obj[path.pop()];
  };
  Vue.$deletePropertyPath = deletePropertyPath
  Object.defineProperties(Vue.prototype, {
    $deletePropertyPath: { get() { return deletePropertyPath } }
  })
  //-----------------------------------------------------------
  function pushOrCreateAndPush(obj, path, value){
    let array = get(obj,path);
    if (!array){
      array = [];
      nestedSet(obj,path,array)
    }
    array.push(value);
  }
  Vue.$pushOrCreateAndPush = pushOrCreateAndPush
  Object.defineProperties(Vue.prototype, {
    $pushOrCreateAndPush: { get() { return pushOrCreateAndPush } }
  })
})

import moment from 'moment'
import 'moment-duration-format'

Vue.use((Vue) => {
  Vue.$moment = moment
  Object.defineProperties(Vue.prototype, {
    $moment: { get() { return moment } }
  })
})

import Ajv from 'ajv'

const ajv = new Ajv({$data: true,formats:{special:".*"},ownProperties:true,verbose:true});

Vue.use((Vue) => {
  Vue.$ajv = ajv
  Object.defineProperties(Vue.prototype, {
    $ajv: { get() { return ajv } }
  })
})


import Noty from 'noty'
import 'noty/lib/noty.css'
import 'noty/lib/themes/semanticui.css'
import 'noty/lib/themes/nest.css'
import 'noty/lib/themes/sunset.css'

Vue.use((Vue) => {

  const defaults = {
    layout: 'bottomRight',
    theme: 'semanticui',
    timeout: 5000,
    progressBar: true,
    closeWith: ['click'],
  }

  const VueNoty = {
    options: {},

    setOptions (opts) {
      this.options = Object.assign({}, defaults, opts)
      return this
    },

    show (text, type = 'alert', opts = {}) {
      const params = Object.assign({}, this.options, opts, {
        type,
        text
      })

      return new Noty(params).show()
    },

  }

  const noty = VueNoty.setOptions({})

  Vue.$noty = noty
  Object.defineProperties(Vue.prototype, {
    $noty: { get() { return noty } }
  })

})


import * as jsonSchemeUtils from '@/utils/jsonSchemeUtils'

Vue.use((Vue) => {
  Vue.$jsonSchemeUtils = jsonSchemeUtils
  Object.defineProperties(Vue.prototype, {
    $jsonSchemeUtils: { get() { return jsonSchemeUtils } }
  })
})

import * as compLayouts from '@/utils/compLayouts'

Vue.use((Vue) => {
  Vue.$compLayouts = compLayouts
  Object.defineProperties(Vue.prototype, {
    $compLayouts: { get() { return compLayouts } }
  })
})

import * as userUtils from '@/utils/userUtils'

Vue.use((Vue) => {
  Vue.$userUtils = userUtils
  Object.defineProperties(Vue.prototype, {
    $userUtils: { get() { return userUtils } }
  })
})

import * as commonUtils from '@/utils/commonUtils'

Vue.use((Vue) => {
  Vue.$commonUtils = commonUtils
  Object.defineProperties(Vue.prototype, {
    $commonUtils: { get() { return commonUtils } }
  })
})

import * as d3Utils from '@/utils/d3Utils'

Vue.use((Vue) => {
  Vue.$d3Utils = d3Utils
  Object.defineProperties(Vue.prototype, {
    $d3Utils: { get() { return d3Utils } }
  })
})

import * as tableLayout from '@/utils/tableLayout'

Vue.use((Vue) => {
  Vue.$tableLayout = tableLayout
  Object.defineProperties(Vue.prototype, {
    $tableLayout: { get() { return tableLayout } }
  })
})

Vue.use((Vue) => {
  function axiosHelper(baseParams,params,dstObj,catchFun=()=>{}){
     Vue.axios(merge(baseParams,params)).then(responce=>{
        forOwn(responce.data,(value,key)=>Vue.set(dstObj,key,value))
     }).catch(catchFun)
  }
  Vue.$axiosHelper = axiosHelper
  Object.defineProperties(Vue.prototype, {
    $axiosHelper: { get() { return axiosHelper } }
  })
})



import VueAsyncProperties from 'vue-async-properties'
Vue.use(VueAsyncProperties,{
 //transform(result) { return result },//TODO почему не работает
})


Vue.directive('show-validate-errors', {
  inserted: function (el,binding) {
    var textErrorDiv = document.createElement('div');
    textErrorDiv.style.display = "none";
    //textErrorDiv.style.marginTop = "-100px"
    let prevChild = el.lastChild;
    el.appendChild(textErrorDiv);
    let marginBottom = getComputedStyle(prevChild)['margin-bottom'];
    if(marginBottom.startsWith("-")) marginBottom=marginBottom.replace("-","");
    else marginBottom="-"+marginBottom;
    textErrorDiv.style.marginTop = marginBottom;
    textErrorDiv.style.position = "absolute"
    textErrorDiv.style.color="#e40303";
  },
  update: function (el,binding) {
    const errors = binding.value;
    if (errors&&errors.length>0){
      var textErrorDiv = el.lastChild;
      textErrorDiv.style.display = "block";
      textErrorDiv.innerHTML = errors.join(",");
    } else{
      var textErrorDiv = el.lastChild;
      textErrorDiv.style.display = "none"
    }

  }
})


